import { useEffect, useState, useCallback } from "react";
import type { FC } from "react";
import useMounted from "../../hooks/useMounted";
import { Link as RouterLink, useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import {
    Avatar,
    Box,
    Button,
    Divider,
    Drawer,
    Link,
    Typography,
} from "@material-ui/core";
import type { Theme } from "@material-ui/core";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import useAuth from "../../hooks/useAuth";
import PSCNavSection from "../PSCNavSection";
import Scrollbar from "../Scrollbar";
import menuService from "../../UIS_services/AuthenticationService/menuService";
import Renderskeleton from "../skeleton/Menuskeleton";
import CustomIcon from "../../icons/CustomIcon";
import Authconfig from "../../config";
import UEHLogo from "../UEHLogo";
// import studentService from '../../UIS_services/StudentService/studentService'
import toast from "react-hot-toast";
import useAvatar from "../..//hooks/useAvatar";
import { useTranslation } from "react-i18next";
interface PSCDashboardSidebarProps {
    onMobileClose: () => void;
    openMobile: boolean;
}
interface IMenu {
    title: string;
    items: { title: string; path: string; icon: JSX.Element }[];
}
interface User {
    username: string;
    routerinfo: string;
}
const PSCDashboardSidebar: FC<PSCDashboardSidebarProps> = (props) => {
    const { i18n } = useTranslation();

    const { onMobileClose, openMobile } = props;
    const location = useLocation();
    const { user } = useAuth();
    const lgUp = useMediaQuery((theme: Theme) => theme.breakpoints.up("lg"));

    const [menu, setMenu] = useState<IMenu[]>([] as IMenu[]);
    const [userstate, setUserState] = useState<User>({
        username: "",
        routerinfo: "",
    } as User);
    // const mounted = useMounted();
    const avatar = useAvatar();
    // console.log(avatar);
    // const [avatar, Setavatar] = useState("");
    //
    async function apiMenu() {
        try {
            //MYuis
            // let data = await menuService.GetMenu(i18n.language);
            let data = await menuService.GetMenu("vi");
            // let data = await menuService.GetMenuQLGD(user?.Role != "NV" ? user?.Role : "AD");
            let arr: {
                title: string;
                items: { title: string; path: string; icon: JSX.Element }[];
            }[] = [];

            data.forEach((x) => {
                let lstItem = x.childMenu.map((el) => {
                    return {
                        title: el.TenChucNang,
                        path: el.LienKet,
                        icon: (
                            <CustomIcon
                                name={el.DoHoaDeThuong}
                                fontSize="small"
                            />
                        ),
                    };
                });

                let tmp = {
                    title: x.TenChucNang,
                    items: lstItem,
                };
                arr.push(tmp);
            });
            // localStorage.setItem("AuthMenu", JSON.stringify(arr));
            // console.log(JSON.stringify(arr))
            setMenu(arr);
        } catch (error) {
            throw error;
        }
    }

    // const InitalData = useCallback(async () => {
    //     try {
    //         let data = await studentService.GetAvatar();
    //         if (mounted.current && data) {
    //             Setavatar(data.data);
    //         }
    //     } catch (error) {
    //         toast.error(error.response.data);
    //     }
    // }, [mounted]);

    // useEffect(() => {
    //     InitalData();
    // }, [InitalData]);

    useEffect(() => {
        // if (menu.length == 0) {
        //     apiMenu();
        // }
        apiMenu();
    }, [i18n.language]);

    useEffect(() => {
        if (openMobile && onMobileClose) {
            onMobileClose();
        }
        if (userstate.username == "") {
            CheckRouterImage();
        }
    }, [location.pathname]);

    function CheckRouterImage() {
        // debugger;
        let data = Authconfig();
        if (data.Role == "SV") {
            setUserState((prev) => {
                return {
                    ...prev,
                    username: data.Username,
                    routerinfo: "/student",
                };
            });
        }
        if (data.Role == "GV") {
            let currentUser: User = {
                username: data.Username,
                routerinfo: "/professor",
            };
            setUserState(currentUser);
        }
        if (data.Role == "NV") {
            let currentUser: User = {
                username: data.Username,
                routerinfo: "/staff",
            };
            setUserState(currentUser);
        }
        if (data.Role == "AD") {
            let currentUser: User = {
                username: data.Username,
                routerinfo: "/staff",
            };
            setUserState(currentUser);
        }
    }
    const content = (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                height: "100%",
            }}
        >
            {menu.length == 0 ? (
                <Renderskeleton loading />
            ) : (
                <Scrollbar options={{ suppressScrollX: true }}>
                    <Box
                        sx={{
                            // display: {
                            //   lg: 'none',
                            //   xs: 'flex'
                            // },
                            // justifyContent: "flex-start",
                            // pl: 6,
                            pt: 1,
                            pb: 1,
                        }}
                    >
                        <RouterLink to="/">
                            {/* <Logo
              sx={{
                height: 40,
                width: 40
              }}
            /> */}
                            <Box
                                sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                }}
                            >
                                <UEHLogo
                                    width="100px"
                                />
                            </Box>
                        </RouterLink>
                    </Box>
                    <Divider
                        sx={{ borderColor: "rgba(145, 158, 171, 0.24)" }}
                    />
                    <Box sx={{ p: 2 }}>
                        <Box
                            sx={{
                                alignItems: "center",
                                backgroundColor: "background.primary",
                                borderRadius: 1,
                                display: "flex",
                                overflow: "hidden",
                                p: 2,
                            }}
                        >
                            <RouterLink to={userstate.routerinfo}>
                                <Avatar
                                    src={avatar ? avatar : ""}
                                    sx={{
                                        backgroundColor: "#757575",
                                        color: "text.primary",
                                        cursor: "pointer",
                                        height: 48,
                                        width: 48,
                                    }}
                                />
                            </RouterLink>
                            <Box sx={{ ml: 2, textAlign: "center" }}>
                                <Typography
                                    color="text.primary"
                                    variant="subtitle2"
                                >
                                    {userstate.username}
                                </Typography>
                                <Typography color="#919eab" variant="body2">
                                    { }
                                    {Authconfig().Role == "SV"
                                        ? "Sinh viên"
                                        : Authconfig().Role == "GV"
                                            ? "Giảng viên"
                                            : "Nhân viên"}
                                    <Link
                                        color="primary"
                                        component={RouterLink}
                                        to="/pricing"
                                    >
                                        {user.plan}
                                    </Link>
                                </Typography>
                            </Box>
                        </Box>
                    </Box>
                    <Divider
                        sx={{ borderColor: "rgba(145, 158, 171, 0.24)" }}
                    />
                    <Box sx={{ p: 2 }}>
                        {/* {menu.length==0&&(
            <Renderskeleton loading/>
          )} */}
                        {menu.map((section) => (
                            <PSCNavSection
                                key={section.title}
                                pathname={location.pathname}
                                sx={{
                                    "& + &": {
                                        mt: 3,
                                    },
                                }}
                                {...section}
                            />
                        ))}
                    </Box>
                    {/* <Divider
                        sx={{ borderColor: "rgba(145, 158, 171, 0.24)" }}
                    />
                    <Box sx={{ p: 2 }}>
                        <Typography color="text.pscprimary" variant="subtitle2">
                            Need Help?
                        </Typography>
                        <Typography color="textSecondary" variant="body2">
                            Check our docs
                        </Typography>
                        <Button
                            color="primary"
                            component={RouterLink}
                            fullWidth
                            sx={{ mt: 2 }}
                            to="/docs"
                            variant="contained"
                        >
                            Documentation
                        </Button>
                    </Box> */}
                </Scrollbar >
            )
            }
        </Box >
    );

    if (lgUp) {
        return (
            <Drawer
                anchor="left"
                open
                PaperProps={{
                    sx: {
                        backgroundColor: "background.pscdefault",
                        // height: 'calc(100% - 64px) !important',
                        // top: '64px !Important',
                        width: 280,
                    },
                }}
                variant="permanent"
            >
                {content}
            </Drawer>
        );
    }

    return (
        <Drawer
            anchor="left"
            onClose={onMobileClose}
            open={openMobile}
            PaperProps={{
                sx: {
                    backgroundColor: "background.pscdefault",
                    width: 280,
                },
            }}
            variant="temporary"
        >
            {content}
        </Drawer>
    );
};

PSCDashboardSidebar.propTypes = {
    onMobileClose: PropTypes.func,
    openMobile: PropTypes.bool,
};

export default PSCDashboardSidebar;
